import { render, staticRenderFns } from "./CloudUploadIcon.vue?vue&type=template&id=5d71f207"
import script from "./CloudUploadIcon.vue?vue&type=script&lang=ts"
export * from "./CloudUploadIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports